module.exports = __webpack_public_path__ + "img/zimmer-frei-1.2966b123.jpg";